// Chaves Pix oficiais do Instituto — TODO: confirmar formatação com a equipe financeira.
// Usadas tanto para o QR Code (BR Code) quanto para a lista copiável no modal.
export const PIX_KEYS = [
  {
    id: "cnpj",
    label: "CNPJ (principal)",
    display: "40.787.623/0001-70",
    raw: "40787623000170", // somente dígitos — formato usado na BR Code
    type: "cnpj",
    primary: true,
  },
  {
    id: "email",
    label: "E-mail",
    display: "institutoga2022@gmail.com",
    raw: "institutoga2022@gmail.com",
    type: "email",
    primary: false,
  },
  {
    id: "aleatoria",
    label: "Chave aleatória",
    display: "ef119fdc-2338-4eb7-8f56-9cafc88c8c39",
    raw: "ef119fdc-2338-4eb7-8f56-9cafc88c8c39",
    type: "evp",
    primary: false,
  },
];

export const PIX_RECEIVER = {
  name: "Instituto GA",
  city: "RECIFE",
};

export function getPrimaryPixKey() {
  return PIX_KEYS.find((k) => k.primary) ?? PIX_KEYS[0];
}
